import React from 'react';
import _, { fill } from 'lodash';
import classNames from 'classnames';
import history from 'app-history';
import { useMfaDevicesWithConnections } from '../../../routes/mfa/hooks/use-mfa-devices';
import useMfaPanelStore from 'modules/mfa-panels/store';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';
import { useResponsive } from 'hooks';

const styles = {
    phoneContainer: {
        width: 60,
        height: 34,
        flexShrink: 0,
    },
    phoneContainerMobile: {
        width: 30,
        height: 30,
        flexShrink: 0,
    },
    colorDot: {
        width: 13,
        height: 13,
    },
    phoneLink: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        color: '#ffffff',
        width: '100%',
        height: '100%',
    },
    phoneLinkInMenu: {
        padding: '0 0 4px 0',
    },
    colorDotInMenu: {
        margin: '3px 0 0 0'
    }
};

export default function TeamPhoneButton({ team, title = "Access team phone", inMenu = false }) {
    const { data: devices = [] } = useMfaDevicesWithConnections();
    const device = _.find(devices, (d) => _.get(d, 'team.id') === team?.id);
    const { isPhone, isTablet, isDesktop } = useResponsive();
    const openPanel = useMfaPanelStore((s) => s.openPanel);

    if (!device) return null;

    const connectedUsers = device.connectedUsers || [];
    const tooltipTitle = connectedUsers.length
        ? `${title} — in use by ${connectedUsers.join(', ')}`
        : title;

    const handleClick = (event) => {
        event.preventDefault();
        // Floating cards don't fit on phones; fall back to the full connect page there.
        if (isPhone) history.push(`/mfa/${device.id}/connect`);
        else openPanel(device.id);
    };

    return (
        <div className='rounded-pill bg-asbestos mr-1' style={{ position: 'relative' }}>
            <Tooltip title={tooltipTitle} placement="bottom" className="d-flex align-items-center justify-content-center" style={{ ...((isPhone || isTablet) ? styles.phoneContainerMobile : styles.phoneContainer) }} >
                <a
                    href={`/mfa/${device.id}/connect`}
                    onClick={handleClick}
                    style={inMenu ? { ...styles.phoneLink, ...styles.phoneLinkInMenu } : styles.phoneLink}
                >
                    {team?.color && <span className="rounded-circle" style={{ ...styles.colorDot, backgroundColor: team.color, ...(inMenu ? styles.colorDotInMenu : {}) }} />}
                    {!isTablet && !isPhone && <SVG src="svg/mobile_2.svg" />}
                </a>
            </Tooltip>
            {connectedUsers.length > 0 && (
                <span className="rounded-circle" style={{
                    position: 'absolute', top: -2, right: -2, width: 9, height: 9,
                    backgroundColor: '#f44336', border: '1.5px solid white'
                }} />
            )}
        </div>
    );
}